import { stylesheet } from 'typestyle';
import { colors, font } from '../../assets/styles';

const styles = stylesheet({
  container: {
  },
  content: {
    margin: '20px',
    textAlign: 'center',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 40,
    width: 40,
  },
  text: {
    height: 100,
  },
  header: {
    fontSize: 28,
    fontWeight: font.weight.light,
    marginBottom: 12,
    lineHeight: '33px',
    textTransform: 'capitalize',
  },
  description: {
    color: colors.foregroundLighter,
    fontSize: 16,
    lineHeight: '22px',
  },
  button: {
    fontSize: '16px !important',
    fontWeight: font.weight.bold,
    letterSpacing: '-.12px',
  },
  QrProcessCardTitle: {
    width: '100%',
    fontSize: 24,
    lineHeight: '30px',
    color: '#0076cc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15,
  },
});

export default styles;
